import SvgIcon from '@mui/material/SvgIcon'

const MyMoveLogoIcon = (props) => (
  <SvgIcon viewBox="107 160 266 156" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M321.715 177.55L372.315 265.281C381.988 282.049 376.193 303.689 359.441 313.371C342.69 323.052 321.071 317.254 311.4 300.486L290.907 264.959L271.204 299.118C268.295 305.697 263.398 311.459 256.731 315.31C239.98 324.992 218.361 319.193 208.688 302.426L158.086 214.695C148.414 197.927 154.209 176.285 170.96 166.605C187.711 156.923 209.331 162.722 219.003 179.49L238.993 214.149L260.102 177.55C266.427 166.587 277.861 160.353 289.704 160.029C290.104 160.013 290.506 160.004 290.907 160C291.311 160.004 291.711 160.013 292.113 160.029C303.954 160.353 315.39 166.587 321.715 177.55ZM187.972 204.453C193.287 204.453 197.594 200.131 197.594 194.799C197.594 189.465 193.287 185.143 187.972 185.143C182.659 185.143 178.35 189.465 178.35 194.799C178.35 200.131 182.659 204.453 187.972 204.453Z"
      fill="currentColor"
    />
    <path
      opacity="0.45"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M107.687 267.195C98.0107 283.971 103.806 305.622 120.569 315.308C137.331 324.994 158.964 319.193 168.642 302.415L219.277 214.644C228.953 197.866 223.156 176.217 206.394 166.531C189.631 156.845 168 162.646 158.321 179.422L107.687 267.195ZM187.972 204.453C193.287 204.453 197.594 200.131 197.594 194.799C197.594 189.465 193.287 185.143 187.972 185.143C182.659 185.143 178.35 189.465 178.35 194.799C178.35 200.131 182.659 204.453 187.972 204.453Z"
      fill="currentColor"
    />
  </SvgIcon>
)

export default MyMoveLogoIcon
